import { render, staticRenderFns } from "./boletim.vue?vue&type=template&id=4ca7e396&"
import script from "./boletim.vue?vue&type=script&lang=js&"
export * from "./boletim.vue?vue&type=script&lang=js&"
import style0 from "./boletim.vue?vue&type=style&index=0&id=4ca7e396&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports